<template>
  <div>
    <div class="craigBox">
      <ul @mouseleave="totalLeave">
        <li @mouseover="mouseOver(1)" 
            @mouseleave="mouseLeave(1)" 
            ref="liFirst"
            :class="controlImg.baozhiImgs ? 'bzBkgImg' : ''">
    
          <p :class="controlImg.baozhiImgs ? 'textColor1' : 'textColor'">
            <span>权威平台</span>
            <img src="../../assets/imgs/home/icon.png" alt="">
          </p>
          <div class="wanzhengText" v-if="controlImg.baozhiImgs" >
         
          <div class="about-standard-item">
             <div class="about-standard-item-title">权威平台</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">


          {{ $store.state.common.appName }}，红狮金业有限公司旗下交易平台<br/>
          香港黄金交易所AA类081号行员<br/>
          多次获得“最佳贵金属平台”“优秀交易平台”等称号
        </div>
      </div>
         
          </div>
          <img class="btmBanner" :class="controlImg.baozhiImgs ? 'OpacityImg' : ''" src="../../assets/imgs/home/advantage.png" alt="">
          
        </li>
        <li ref="liSecond"
        style="position: relative;"
            @mouseover="mouseOver(2)" 
            @mouseleave="mouseLeave(2)"
            :class="controlImg.sxjzImgs ? 'sxjzBkgImg' : ''">

          
          <div class="wanzhengText" v-if="controlImg.sxjzImgs" >
              <div class="about-standard-item">
             <div class="about-standard-item-title">资金安全</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                 出入金顺畅，资金安全有保障<br/>
                 可在APP或用户中心<br/>
                 即时查看资金变动的具体情况

                </div>
             </div>
            
          </div>
           <p :class="controlImg.sxjzImgs ? 'textColor1' : 'textColor'">
            <span>资金安全</span>
            <img src="../../assets/imgs/home/icon.png" alt="">
          </p>
          <img class="btmBanner" :class="controlImg.sxjzImgs ? 'OpacityImg' : ''" src="../../assets/imgs/home/advantage1.png" alt="">
          
        </li>
        <li ref="liThird"
            @mouseover="mouseOver(3)" 
            @mouseleave="mouseLeave(3)"
            :class="controlImg.sctmImgs ? 'sctmBkgImg' : ''">
      
          <p  :class="controlImg.sctmImgs ? 'textColor1' : 'textColor'">
            <span>服务专业</span>
            <img src="../../assets/imgs/home/icon.png" alt="">

          </p>
          <div class="wanzhengText" v-if="controlImg.sctmImgs" >
               <div class="about-standard-item">
             <div class="about-standard-item-title">服务专业</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                7*24小时专业客服<br/>
                随时解决您任何投资疑问<br/>
                 贴心服务助您财富增长
        </div>
      </div>
          </div>
          <img class="btmBanner" :class="controlImg.sctmImgs ? 'OpacityImg' : ''" src="../../assets/imgs/home/advantage2.png" alt="">
        </li>
        <li ref="liFourth"
            @mouseover="mouseOver(4)" 
            @mouseleave="mouseLeave(4)"
            :class="controlImg.jylhImgs ? 'jylhkgImg' : ''">
     
          <p  :class="controlImg.jylhImgs ? 'textColor1' : 'textColor'">
            <span>丰富活动</span>
                        <img src="../../assets/imgs/home/icon.png" alt="">

          </p>
          <div class="wanzhengText" v-if="controlImg.jylhImgs" >
               <div class="about-standard-item">
             <div class="about-standard-item-title">丰富活动</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                享优越点差，省即是赚<br/>
                同时还有丰富的新用户注册活动<br/>
                享赠金好礼
        </div>
      </div>
          </div>
          <img class="btmBanner" :class="controlImg.jylhImgs ? 'OpacityImg' : ''" src="../../assets/imgs/home/advantage3.png" alt="">
        </li>
        <li ref="liFifth"
            @mouseover="mouseOver(5)" 
            @mouseleave="mouseLeave(5)"
            :class="controlImg.yzsImgs ? 'yzsImg' : ''">
     
          <p  :class="controlImg.yzsImgs ? 'textColor1' : 'textColor'">
            <span>软件强大</span>
                        <img src="../../assets/imgs/home/icon.png" alt="">

          </p>
          <div class="wanzhengText" v-if="controlImg.yzsImgs" >
              <div class="about-standard-item">
             <div class="about-standard-item-title">软件强大</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                全新智能化软件，独家开发交易利器<br/>
                超强下单执行能力<br/>
                是您交易的强大后盾
        </div>
      </div>

          </div>
          <img class="btmBanner" :class="controlImg.yzsImgs ? 'OpacityImg' : ''" src="../../assets/imgs/home/advantage4.png" alt="">
        </li>
      </ul>
    </div>
    <div class="craigBoxs">
      <ul >
        <li class="bzBkgImg"> 
        <div class="wanzhengText">
         
          <div class="about-standard-item">
             <div class="about-standard-item-title">权威平台</div>
               <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                 {{ $store.state.common.appName }}红狮金业有限公司旗下交易平台<br/>
                 香港黄金交易所AA类081号行员<br/>
                 多次获得“最佳贵金属平台”“优秀交易平台”等称号 
                </div>
              </div>
         
          </div>       
        </li>
        <li class="sxjzBkgImg">
          <div class="wanzhengText"  >
              <div class="about-standard-item">
             <div class="about-standard-item-title">资金安全</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                 出入金顺畅，资金安全有保障<br/>
                 可在APP或用户中心<br/>
                 即时查看资金变动的具体情况

                </div>
             </div>
            
          </div>
          
        </li>
        <li  class="sctmBkgImg">
          <div class="wanzhengText"  >
               <div class="about-standard-item">
             <div class="about-standard-item-title">服务专业</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                7*24小时专业客服<br/>
                随时解决您任何投资疑问<br/>
                 贴心服务助您财富增长
               </div>
             </div>
          </div> 
        </li>
        <li class="jylhkgImg">
          <div class="wanzhengText">
               <div class="about-standard-item">
             <div class="about-standard-item-title">丰富活动</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                享优越点差，省即是赚<br/>
                同时还有丰富的新用户注册活动<br/>
                享赠金好礼
               </div>
              </div>
          </div>
         
        </li>
        <li class="yzsImg">
          <div class="wanzhengText" >
              <div class="about-standard-item">
             <div class="about-standard-item-title">软件强大</div>
                <span class="about-standard-item-line"></span>
               <div class="about-standard-item-content">
                全新智能化软件，独家开发交易利器<br/>
                超强下单执行能力<br/>
                是您交易的强大后盾
                </div>
              </div>

          </div>
          
        </li>
      </ul>
    </div>
  </div>
    
</template>

<script>
export default {
    data(){
        return{
            // 控制craigBox
        controlImg:{
          baozhiImgs: true,
          sxjzImgs: false,
          sctmImgs: false,
          jylhImgs: false,
          yzsImgs:false
        },
        // 控制serveBox
        controlDiv:1,
        }
    },
     mounted() {
     
     },
methods:{
     // 鼠标移入事件
      mouseOver(attr){
        switch (attr) {
          case 1:
            this.controlImg.baozhiImgs = true;
            break;
          case 2:
            this.controlImg.sxjzImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
          case 3:
            this.controlImg.sctmImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
          case 4:
            this.controlImg.jylhImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
          case 5:
            this.controlImg.yzsImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
        }
      },
      // 鼠标移出事件
      mouseLeave(attr){
        switch(attr){
          case 1:
            this.controlImg.baozhiImgs = false;
            break;
          case 2:
            this.controlImg.sxjzImgs = false;
            break;
          case 3:
            this.controlImg.sctmImgs = false;
            break;
          case 4:
            this.controlImg.jylhImgs = false;
            break;
          case 5:
            this.controlImg.yzsImgs = false;
            break;
        }
      },
      // 鼠标移出整个box时，设置默认展开栏
      totalLeave(){
        this.controlImg.baozhiImgs = true;
      },
}
}
</script>

<style lang="less" scoped>
.craigBox{
  display: block;
      width: 100%;
      box-sizing: border-box;
      padding: 60px 0;
      background: #fff;
      background-size: cover;
      ul{
        width: 1130px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        li{
          width: 25%;
          height: 540px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;
          box-sizing: border-box;
          border-right: 5px solid #f8f8f8;
          padding: 50px 0 0 0px;
          position: relative;
          background-color: #fff;
          .btmBanner{
            position: absolute;
            right: 0;
            bottom: 0;
            height: 540px;
          }
          p{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
               position: absolute;
          bottom: 0px;
          left: 9px;
          z-index: 10;
           width: 140px;
            // height: 246px;
            padding: 71px 0 56px 0;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);

          img{
            margin-top: 61px;
          }
            span{
              font-size: 14px;
              color: #6d6d6d;
            }
            span:nth-child(1){
              font-size: 16px;
              font-weight: 600;
              color: #121212;
            }
          }
        }
        .wanzhengText{
          width: 65%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end !important;
          align-items: flex-start;
          p{
           
            color: #fff;
            margin: 0;
            text-align: justify;
            line-height: 26px;

          }
          p:nth-child(2){
            font-size: 22px;
            color: #fff;
            margin: 30px 0 10px;
          }
        }
        .bzBkgImg{
          background: url('../../assets/imgs/home/cart.png') no-repeat;
          background-size: cover;
          width: 45%;
        
        }
        .sxjzBkgImg{
          background: url('../../assets/imgs/home/cart1.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .sctmBkgImg{
          background: url('../../assets/imgs/home/cart2.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .jylhkgImg{
          background: url('../../assets/imgs/home/cart3.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .yzsImg{
          background: url('../../assets/imgs/home/cart4.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        li .textColor span{
          color: #fff !important;
       
        }
        li .textColor1 {
          display: none;
        }
        li .OpacityImg{
           height: 540px;
          display: none;
        }
      }
       .about-standard {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 506px;
      height: 336px;
      color: #FFFFFF;
      // margin-bottom: 28px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end; /* 垂直居下 */
      box-sizing: border-box;
      padding: 30px ;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);
      
     


      &-title {
        font-size: 26px;
        font-weight: 700;
      }
      &-line {
        width: 40px;
        height: 4px;
        display: inline-block;
        background: #FA2314;
        margin: 16px 0;
      }
      &-content{
        line-height: 28px;
      }
    }
  }
    }
.craigBoxs{
      display: none;
      width: 100%;
      box-sizing: border-box;
      // padding: 60px 0;
      background: #fff;
      background-size: cover;
         ul{
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        li{
          
          width: 343px;
          height: 196px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;
          box-sizing: border-box;
          border-right: 5px solid #f8f8f8;
          padding: 50px 0 0 0px;
          position: relative;
          background-color: #fff;
        
          p{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
               position: absolute;
          bottom: 0px;
          left: 9px;
          z-index: 10;
           width: 140px;
            // height: 246px;
            padding: 71px 0 56px 0;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);

          img{
            margin-top: 61px;
          }
            span{
              font-size: 14px;
              color: #6d6d6d;
            }
            span:nth-child(1){
              font-size: 16px;
              font-weight: 600;
              color: #121212;
            }
          }
        }
        .wanzhengText{
          width: 343px;
          height: 196px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end !important;
          align-items: flex-start;
          p{
           
            color: #fff;
            margin: 0;
            text-align: justify;
            line-height: 26px;

          }
          p:nth-child(2){
            font-size: 22px;
            color: #fff;
            margin: 30px 0 10px;
          }
        }
        .bzBkgImg{
          background: url('../../assets/imgs/home/wap/cart.png') no-repeat;
          background-size: cover;
          margin-bottom: 16px;
          
        
        }
        .sxjzBkgImg{
          background: url('../../assets/imgs/home/wap/cart1.png') no-repeat;
          background-size: cover;
          margin-bottom: 16px;

        }
        .sctmBkgImg{
          background: url('../../assets/imgs/home/wap/cart2.png') no-repeat;
          background-size: cover;
          margin-bottom: 16px;
          
        }
        .jylhkgImg{
          background: url('../../assets/imgs/home/wap/cart3.png') no-repeat;
          background-size: cover;
          margin-bottom: 16px;
          
        }
        .yzsImg{
          background: url('../../assets/imgs/home/wap/cart4.png') no-repeat;
          background-size: cover;
      margin-bottom: 16px;
          
        }
        li .textColor span{
          color: #fff !important;
       
        }
        li .textColor1 {
          display: none;
        }
        li .OpacityImg{
           height: 540px;
          display: none;
        }
      }
       .about-standard {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 337px;
      // height: 102px;
      color: #FFFFFF;
      // margin-bottom: 28px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end; /* 垂直居下 */
      box-sizing: border-box;
      padding: 30px 0 30px 30px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);

      &-title {
        font-size: 14px;
        font-weight: 700;
      }
      &-line {
        width: 22px;
        height: 2px;
        display: inline-block;
        background: #FA2314;
        margin: 6px 0;
      }
      &-content{
        line-height: 16px;
        font-size: 10px;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .craigBox{
    display: none;
  }
  .craigBoxs{
    display: block;
  }
}
   // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
    .craigBox {
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 60px 0;
        background: #fff;
        background-size: cover;
    
        ul {
          width: 1000px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
    
          li {
            width: 25%;
            height: 540px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;
            box-sizing: border-box;
            border-right: 5px solid #f8f8f8;
            padding: 50px 0 0 0px;
            position: relative;
            background-color: #fff;
    
            .btmBanner {
              position: absolute;
              right: 0;
              bottom: 0;
              height: 540px;
            }
    
            p {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              position: absolute;
              bottom: 0px;
              left: 9px;
              z-index: 10;
              width: 140px;
              // height: 246px;
              padding: 71px 0 56px 0;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);
    
              img {
                margin-top: 61px;
              }
    
              span {
                font-size: 14px;
                color: #6d6d6d;
              }
    
              span:nth-child(1) {
                font-size: 16px;
                font-weight: 600;
                color: #121212;
              }
            }
          }
    
          .wanzhengText {
            width: 65%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end !important;
            align-items: flex-start;
    
            p {
    
              color: #fff;
              margin: 0;
              text-align: justify;
              line-height: 26px;
    
            }
    
            p:nth-child(2) {
              font-size: 22px;
              color: #fff;
              margin: 30px 0 10px;
            }
          }
    
          .bzBkgImg {
            background: url('../../assets/imgs/home/cart.png') no-repeat;
            background-size: cover;
            width: 40%;
    
          }
    
          .sxjzBkgImg {
            background: url('../../assets/imgs/home/cart1.png') no-repeat;
            background-size: cover;
            width: 40%;
          }
    
          .sctmBkgImg {
            background: url('../../assets/imgs/home/cart2.png') no-repeat;
            background-size: cover;
            width: 40%;
          }
    
          .jylhkgImg {
            background: url('../../assets/imgs/home/cart3.png') no-repeat;
            background-size: cover;
            width: 40%;
          }
    
          .yzsImg {
            background: url('../../assets/imgs/home/cart4.png') no-repeat;
            background-size: cover;
            width: 40%;
          }
    
          li .textColor span {
            color: #fff !important;
    
          }
    
          li .textColor1 {
            display: none;
          }
    
          li .OpacityImg {
            height: 540px;
            display: none;
          }
        }
    
        .about-standard {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
    
          &-item {
            width: 396px;
            height: 336px;
            color: #FFFFFF;
            // margin-bottom: 28px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            /* 垂直居下 */
            box-sizing: border-box;
            padding: 30px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);
    
    
    
    
            &-title {
              font-size: 26px;
              font-weight: 700;
            }
    
            &-line {
              width: 40px;
              height: 4px;
              display: inline-block;
              background: #FA2314;
              margin: 16px 0;
            }
    
            &-content {
              line-height: 28px;
            }
          }
        }
      }
  }
</style>